import { getters } from './getters';
import * as actions from './actions';
import { mutations } from './mutations';
import { loginInitialState } from './models';


export const loginModule = {
  state: loginInitialState,
  getters,
  actions,
  mutations,
};
